import { Link } from "react-router-dom";
import { Phone, MessageSquare, Mail, MapPin } from "lucide-react";
import { SOCIALS } from "./Socials";
import { BIZ } from "@/data/business";
import { MaskLines } from "./motion";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 pt-20 pb-28 md:pb-12 overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 flex items-start gap-5">
          <img src="/velocity-badge.png" alt="Velocity Detailing" className="h-24 w-auto" />
          <div>
            <p className="font-display font-black uppercase text-xl">Velocity Detailing</p>
            <p className="mt-2 text-sm text-slate-400 max-w-xs">Luxury car & boat detailing. Automotive, marine and RV — Vernon, BC.</p>
          </div>
        </div>
        <ul className="lg:col-span-7 grid sm:grid-cols-2 gap-5 text-sm">
          <li><a href={BIZ.tel} data-testid="footer-call" className="flex items-center gap-3 hover:text-[#6fd6ff] transition-colors"><Phone className="h-4 w-4 text-[#1bb4f2]" />Call {BIZ.phone}</a></li>
          <li><a href={BIZ.sms} data-testid="footer-text" className="flex items-center gap-3 hover:text-[#6fd6ff] transition-colors"><MessageSquare className="h-4 w-4 text-[#1bb4f2]" />Text {BIZ.phone}</a></li>
          <li><a href={`mailto:${BIZ.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-[#6fd6ff] transition-colors break-all"><Mail className="h-4 w-4 text-[#1bb4f2] shrink-0" />{BIZ.email}</a></li>
          <li><a href={BIZ.maps} target="_blank" rel="noreferrer" data-testid="footer-address" className="flex items-center gap-3 hover:text-[#6fd6ff] transition-colors"><MapPin className="h-4 w-4 text-[#1bb4f2] shrink-0" />{BIZ.address}</a></li>
          <li className="sm:col-span-2 flex flex-wrap gap-2 pt-2">{SOCIALS.map((s) => (
            <a key={s.id} href={s.url} target="_blank" rel="noreferrer" data-testid={`footer-${s.id}`} aria-label={`Follow on ${s.name}`}
              className="inline-flex items-center gap-2 h-10 px-4 border border-white/15 hover:border-[#1bb4f2] hover:text-[#6fd6ff] transition-colors"><s.Icon className="h-4 w-4 text-[#1bb4f2]" />{s.name}</a>
          ))}</li>
        </ul>
      </div>
      <div className="mt-20 font-display font-black uppercase leading-[0.82] text-[15vw] lg:text-[11.5rem] tracking-[-0.03em]">
        <MaskLines lines={["Velocity"]} inView lineClass="outline-text" />
      </div>
      <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
        <span>© {new Date().getFullYear()} Velocity Detailing · Prices in CAD, taxes extra</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Staff login</Link>
      </div>
    </div>
  </footer>
);
